const styles = (theme) => ({
  checkbox: {
    margin: 0,
  },
  checkboxContainer: {
    marginLeft: theme.spacing(1.5),
  },
  checkboxDisabled: {
    '& svg, & .MuiIconButton-label': {
      opacity: 0.5,
    },
  },
});

export default styles;
